/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { login } from "@/actions/auth";
import { Button, Form, Input, Modal } from "antd";
import Language from "@/components/Common/Language";
import intl from "react-intl-universal";
import ercode from "@/assets/image/ercode.png";

import logoImg from "@/assets/image/logo.png";
import styles from "./Login.module.scss";

type FieldType = {
  email?: string;
  mobile?: string;
  password?: string;
};

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("mobile");

  const errorCallback = (errorInfo) => {
    console.log("Failed:", errorInfo);

    if (errorInfo.code === 422 && errorInfo.subCode === 422105) {
      Modal.warning({
        title: intl.get("common_http_title"),
        content: (
          <>
            {intl.get("login_error_422")}
            <img className={styles.ercode} src={ercode} alt="" />
          </>
        ),
        centered: true,
        keyboard: false,
      });
    }
  };
  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await props.login({ ...values }, errorCallback);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.content}>
        <div className={styles.contentForm}>
          <div className={styles.title}>
            <div className={styles.left}>
              <img src={logoImg} alt="" />
              {intl.get("login_title")}
            </div>

            <div className={styles.langBox}>
              <Language />
            </div>
          </div>
          <div className={styles.chooseView}>
            <div
              className={`${type === "mobile" && styles.choose}`}
              onClick={() => {
                setType("mobile");
              }}
            >
              {intl.get("registry_phone")}
            </div>
            <div
              className={`${type === "email" && styles.choose}`}
              onClick={() => {
                setType("email");
              }}
            >
              {intl.get("password_email")}
            </div>
          </div>

          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            onFinish={onFinish}
            layout="vertical"
            autoComplete="off"
          >
            {type === "mobile" && (
              <Form.Item<FieldType>
                name="mobile"
                label={intl.get("registry_phone")}
                rules={[
                  {
                    required: true,
                    message: intl.get("sendEmail_validMobile"),
                    validator(_rule, value, callback) {
                      if (!value) {
                        callback(intl.get("sendEmail_validMobile"));
                      } else if (!/^[0-9]\d*$/.test(value)) {
                        callback(intl.get("sendEmail_validMobile"));
                      } else {
                        callback();
                      }
                    },
                  },
                ]}
              >
                <Input
                  className={styles.addonBeforeLoginIuput}
                  placeholder={intl.get("registry_inputPhone")}
                  autoComplete="off"
                  readOnly={loading}
                  allowClear
                  addonBefore="+86"
                />
              </Form.Item>
            )}

            {type === "email" && (
              <Form.Item<FieldType>
                name="email"
                label={intl.get("login_email")}
                rules={[
                  {
                    required: true,
                    message: intl.get("login_email_placeholder"),
                  },
                  {
                    type: "email",
                    message: intl.get("sendEmail_validAddress"),
                  },
                ]}
              >
                <Input
                  className={styles.loginIuput}
                  // prefix={<UserOutlined />}
                  placeholder={intl.get("login_email_placeholder")}
                  autoComplete="off"
                  readOnly={loading}
                  allowClear
                />
              </Form.Item>
            )}

            <Form.Item<FieldType>
              name="password"
              label={intl.get("login_password")}
              rules={[
                {
                  required: true,
                  message: intl.get("login_password_placeholder"),
                },
              ]}
            >
              <Input.Password
                className={styles.loginIuput}
                // prefix={<LockOutlined />}
                placeholder={intl.get("login_password_placeholder")}
                autoComplete="off"
                readOnly={loading}
                allowClear
              />
            </Form.Item>
            <div className={styles.wjPwdButton}>
              <Button
                type="link"
                onClick={() => {
                  window.location.href = "/password";
                }}
              >
                {intl.get("login_forget_password")}
              </Button>
            </div>
            <Button
              className={styles.loginButton}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {intl.get("login_btn")}
            </Button>

            <div className={styles.tips}>
              {intl.get("login_no_account")}
              <span
                onClick={() => {
                  window.location.href = `/register?type=${type}`;
                }}
              >
                {intl.get("login_create_account")}
              </span>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default withRouter(connect(null, { login })(Login));
